import { History, Location } from 'history';

export function keepRootWithoutTrailingSlash(history: History, basename: string): () => void {
  if (!basename || basename === '/') {
    return () => {};
  }

  const rootPathname = basename;
  const rootPathnameWithSlash = `${basename}/`;

  const syncRootWithoutTrailingSlash = (location: Location) => {
    // history v5 + React Router v6 keep the full path (including basename) on the
    // raw history, so the app root is `rootPathname`/`rootPathnameWithSlash`, not `/`.
    const isRootRoute = location.pathname === rootPathname || location.pathname === rootPathnameWithSlash;
    if (!isRootRoute || window.location.pathname !== rootPathnameWithSlash) {
      return;
    }

    window.history.replaceState(
      window.history.state,
      document.title,
      `${rootPathname}${location.search}${location.hash}`,
    );
  };

  syncRootWithoutTrailingSlash(history.location);
  return history.listen(({ location }) => syncRootWithoutTrailingSlash(location));
}
